
export default {
  name: 'Pagination',
  props: {
    meta: {
      type: Object,
      required: true,
    },
    links: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    cursor: {
      type: Boolean,
      required: false,
      default: false,
    },
    condensed: {
      type: Boolean,
      required: false,
      default: false,
    },
    autoHide: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showPagination() {
      if (this.cursor) {
        return !!(this.links.next || this.links.prev);
      }
      if (this.autoHide) {
        if (this.meta.total > this.meta.per_page) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
  },
};
